import { Button, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import {
    Autocomplete,
    TextField
} from '@mui/material/';
import React, { useContext, useState } from 'react';
import '../App.css';
import FeatureProcessedDataTable from './FeatureProcessedDataTable';
import { SystemContext } from "../context";
import Alert from '@mui/material/Alert';
import CustomSnackbar from '../CustomSnackbar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const FeatureProcessing = ({ fetchAPI }) => {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarType, setSnackbarType] = useState('');
    const { numericalColumns, stringColumns, allColumns, fileName, taskToDoValue, setTaskToDoValue,
        targetVariableValue, setTargetVariableValue,scalingTechniqueValue, setScalingTechniqueValue,featureValue, setFeatureValue,strategForFeatureSelectionValue, setStrategForFeatureSelectionValue, timeStampCols, setTimeStampCols, numericalCleanedCols, setNumericalCleanedCols,
        categoricalCleanedCols, setCategoricalCleanedCols, allCleanedCols, setAllCleanedCols, cleanFlag, balancedCols, setBalancedCols, actualFileName,setKeyMetricValue,setNumberOfModelsToTrain, setImages, setTable1Data,setTable2Data, setTable3Data,setModelName
    } = useContext(SystemContext);
    // const [taskToDoOptions, setTaskToDoOptions] = useState(['Classification', 'Regression', 'Clustering']);
    const [taskToDoOptions, setTaskToDoOptions] = useState(['Classification', 'Regression']);

    const [targetVariableOptions, setTargetVariableOptions] = useState([]);

    const [scalingTechniqueOptions, setScalingTechniqueOptions] = useState(['StandardScaler', 'min-max', 'max-abs', 'robust']);
    // const [scalingTechniqueValue, setScalingTechniqueValue] = useState('');

    const [featureOptions, setFeatureOptions] = useState([]);
    // const [featureValue, setFeatureValue] = useState([]);

    const [isRemainingFeatures, setIsRemainingFeatures] = useState('Yes');
    const [isFilterUsingMulticollinearity, setIsFilterUsingMulticollinearity] = useState('Yes');

    const [vifThresholdValue, setVifThresholdValue] = React.useState(1);
    const [cramersVThresholdValue, setCramersVThresholdValue] = useState('0.01');

    // const [strategForFeatureSelectionValue, setStrategForFeatureSelectionValue] = useState('');
    const [strategForFeatureSelectionOptions, setStrategForFeatureSelectionOptions] = useState(['RandomForestClass']);
    const [strategForFeatureSelectionOptions1, setStrategForFeatureSelectionOptions1] = useState(["RandomForestRegress"]);
    const [featureExtractionMethod, setFeatureExtractionMethod] = useState('');

    const [numberOfFeaturesSelected, setNumberOfFeaturesSelected] = useState('0.01');
    const [isDimReductionRequired, setIsDimReductionRequired] = useState('Yes');
    const [loading, setLoading] = useState(false);

    const [taskToDoError, setTaskToDoError] = useState(false);
    const [targetVarError, setTargetVarError] = useState(false);
    const [scalingError, setScalingError] = useState(false);

    const [featureSeletionStrategyError, setFeatureSeletionStrategyError] = useState(false);
    const [noOfRowsAfterFeatureProcessing, setNoOfRowsAfterFeatureProcessing] = useState('');
    const [noOfColsAfterFeatureProcessing, setNoOfColsAfterFeatureProcessing] = useState('');
    const [selectedFeaturesFromBackend, setSelectedFeaturesFromBackend] = useState([]);
    const [featureStatusMsg, setFeatureStatusMsg] = useState('');


    const [featureExtractionMethodOptions, setFeatureExtractionMethodOptions] = useState([
        "Linear PCA",
        'Incremental PCA',
        'Sparse PCA',
        "RBF Kernel",
        "Poly Kernel",
        "Sigmoid Kernel",
        "Cosine Kernel"
    ]);

    const [finalNumberOfComponents, setFinalNumberOfComponents] = useState('1');

    const [processedData, setProcessedData] = useState({});


    const handleTaskToDo = (evt, value) => {
        setTargetVariableValue("")
        setStrategForFeatureSelectionValue("")
        setNumberOfModelsToTrain([])
        setImages([])
        setTable1Data([])
        setTable2Data([])
        setTable3Data([])
        setModelName("")
        setKeyMetricValue("")
        if (value == null) {
            return;
        }
        setTaskToDoError(false);
        setTaskToDoValue(value)
    }
    const handleTargetVariable = (evt, value) => {
        if (value == null) {
            return;
        }
        setTargetVarError(false)
        setTargetVariableValue(value)
    }

    const handleScaling = (evt, value) => {
        if (value == null) {
            return;
        }
        setScalingError(false);
        setScalingTechniqueValue(value)
    }

    const handleFeature = (evt, value) => {
        if (value == null) {
            return;
        }
        setFeatureValue(value)
    }

    const handleRemainingFeatures = (event) => {
        setIsRemainingFeatures(event.target.value)
    }

    const handleFilterUsingMulticollinearity = (event) => {
        setIsFilterUsingMulticollinearity(event.target.value)
    }

    const handleVIFThresholdChange = (event) => {
        setVifThresholdValue(event.target.value);
    };

    const handleVThresholdValueChange = (event) => {
        setCramersVThresholdValue(event.target.value);
    };

    const handleStrategForFeatureSelectionChange = (event, value) => {
        if (value == null) {
            return;
        }
        setStrategForFeatureSelectionValue(value);
        setFeatureSeletionStrategyError(false);
    }

    const handleNumberOfFeaturesSelectedChange = (event) => {
        setNumberOfFeaturesSelected(event.target.value);
    };

    const handleIsDimReductionRequired = (event) => {
        setIsDimReductionRequired(event.target.value)
    }

    const handleFeatureExtractionMethod = (event) => {
        setFeatureExtractionMethod(event.target.value)
    }

    const handleFinalNumberOfMethodsChange = (event) => {
        setFinalNumberOfComponents(event.target.value);
    };
    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };



    // const handleFeatureProcessingSubmit = async (event) => {
    //     let flag = false;

    //     if (!taskToDoValue) {
    //         setTaskToDoError(true);
    //         flag = true
    //     }
    //     if (!targetVariableValue && taskToDoValue && taskToDoValue != "Clustering") {
    //         setTargetVarError(true);
    //         flag = true
    //     }
    //     if (!scalingTechniqueValue) {
    //         setScalingError(true);
    //         flag = true
    //     }
    //     if (!strategForFeatureSelectionValue && isRemainingFeatures == "Yes" && taskToDoValue && taskToDoValue != "Clustering" ) {
    //         setFeatureSeletionStrategyError(true);
    //         flag = true
    //     }
    //     if (flag) {
    //         return
    //     }
    //     setLoading(true);
    //     let temp = {}
    //     temp["choices"] = {
    //         "Task": taskToDoValue,
    //         "target": targetVariableValue,
    //         "scaleMethod": scalingTechniqueValue,
    //         "features": featureValue,
    //         "remove_multicollinearity": "No",
    //         "automate": isRemainingFeatures,
    //         "feature_selection_method": strategForFeatureSelectionValue,
    //         "feature_extraction_method": "PCA",
    //         "timestamps": timeStampCols,
    //         "dim_reduction": "No",
    //         "dim": 7,
    //         "num_features": 5,
    //     }
    //     temp['filename'] = fileName
    //     try {

    //         const response = await fetchAPI.post('/process', temp, {
    //             headers: {
    //                 Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
    //             }
    //         });
    //         if(response.status == 200){
    //             setFeatureStatusMsg("Features processed successfully!");
    //             setSnackbarOpen(true);
    //             setSnackbarType("success");
    //         }
    //         setProcessedData(response.data.data);
    //         setNoOfRowsAfterFeatureProcessing(response.data.rows_count);
    //         setNoOfColsAfterFeatureProcessing(response.data.cols_count);
    //         setSelectedFeaturesFromBackend(response.data.selected_features)
    //     } catch (error) {
    //         console.error('Error uploading file:', error);
    //         setFeatureStatusMsg(error.response.data.message);
    //         setSnackbarType("error");
    //         setSnackbarOpen(true);
    //     } finally {
    //         setLoading(false);
    //     }

    // }
    const handleFeatureProcessingSubmit = async (event) => {
        let flag = false;

        if (!taskToDoValue) {
            setTaskToDoError(true);
            flag = true
        }
        if (!targetVariableValue && taskToDoValue && taskToDoValue !== "Clustering") {
            setTargetVarError(true);
            flag = true;
        }
        if (!scalingTechniqueValue) {
            setScalingError(true);
            flag = true
        }
        if (!strategForFeatureSelectionValue && isRemainingFeatures == "Yes" && taskToDoValue && taskToDoValue != "Clustering" ) {
            setFeatureSeletionStrategyError(true);
            flag = true
        }
        if (flag) {
            return;
        }
    
        setLoading(true);
        let temp = {
            "choices": {
                "Task": taskToDoValue,
                "target": targetVariableValue,
                "scaleMethod": scalingTechniqueValue,
                "features": featureValue,
                "remove_multicollinearity": "No",
                "automate": isRemainingFeatures,
                "feature_selection_method": strategForFeatureSelectionValue,
                "feature_extraction_method": "PCA",
                "timestamps": timeStampCols,
                "dim_reduction": "No",
                "dim": 7,
                "num_features": 5,
            },
            'filename': actualFileName
        };
    
        try {

            const response = await fetchAPI.post('/process', temp, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });
            
            if (response.status === 202) {
                const pollProcessStats = async () => {
                    try {
                        const processStatsResponse = await fetchAPI.post('/process_stats', { filename: actualFileName }, {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                            }
                        });
                        
                        if (processStatsResponse.data && processStatsResponse.data.json_data && Object.keys(processStatsResponse.data.json_data).length >0) {
                            const data = processStatsResponse.data.json_data
                            setProcessedData(data.data);
                            setNoOfRowsAfterFeatureProcessing(data.rows_count);
                            setNoOfColsAfterFeatureProcessing(data.cols_count);
                            setSelectedFeaturesFromBackend(data.selected_features);
                            setFeatureStatusMsg("Feature stats processed successfully!");
                            setSnackbarOpen(true);
                            setSnackbarType("success");
                            setLoading(false);
                        } else {
                            setTimeout(pollProcessStats, 5000);
                        }
                    } catch (error) {
                        console.error('Error fetching process stats:', error);
                        setFeatureStatusMsg(error.response?.data?.message || "Error fetching process stats");
                        setSnackbarType("error");
                        setSnackbarOpen(true);
                        setLoading(false);
                    }
                };
    
                pollProcessStats();
            }
        } catch (error) {
            console.error('Error processing features:', error);
            setFeatureStatusMsg(error.response?.data?.message || "Error processing features");
            setSnackbarType("error");
            setSnackbarOpen(true);
            setLoading(false);
        }
    };
    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    };

    const boxStyle = {
        borderRadius: "15px",
        border: "2px solid #ccc",
        padding: "15px",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        backgroundColor: "#f9f9f9",
        width: "100%",
        boxSizing: "border-box",
        overflowX: 'auto',
    };

    const parentStyle = {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: 'start',
    };

    const innerContentStyle = {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'start',
        flexDirection: 'column',
    };

    const rowStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        boxSizing: "border-box",
        marginBottom: '0.5rem'
    };

    const autocompleteStyle = {
        flexGrow: 1,
        marginLeft: '1rem',
        minWidth: '250px',
    };

    const headingStyle = {
        color: '#152C73',
        marginRight: '1rem',
    };

    const labelStyle = {
        color: '#152C73',
        marginRight: '1rem',
        display: 'flex',
    };
    const paragraphStyle = {
        whiteSpace: 'wrap',
        textAlign: 'left',
        marginRight: '1rem',
        display : 'flex',
        flexDirection : 'row'
    };

    return (
        <>
            <div style={parentStyle}>
                <div style={boxStyle}>
                    <div style={innerContentStyle}>
                        {/* Task To Do Section */}
                        <div style={{ ...rowStyle, alignItems: 'center', width: '100%' }}>
                            <h3 style={{ ...headingStyle, marginBottom: '1rem', minWidth: '200px', textAlign: 'left' }}><b>Task ToDo</b></h3>
                            <Autocomplete
                                id="combo-box-task-todo"
                                options={taskToDoOptions}
                                value={taskToDoValue}
                                fullWidth
                                style={autocompleteStyle}
                                autoHighlight
                                onChange={handleTaskToDo}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Task ToDo"
                                    placeholder='Please select the task'
                                    error={taskToDoError}
                                    helperText={taskToDoError ? 'Task is mandatory' : ''}
                                />}
                            />
                            <Autocomplete
                                id="combo-box-target-variable"
                                options={taskToDoValue === "Classification" ? categoricalCleanedCols.filter(option => !timeStampCols.includes(option)) : numericalCleanedCols.filter(option => !timeStampCols.includes(option))}                                
                                value={targetVariableValue}
                                disabled={taskToDoValue === "Clustering"}
                                fullWidth
                                style={autocompleteStyle}
                                autoHighlight
                                onChange={handleTargetVariable}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label={taskToDoValue === "Classification" ? "Target Variable For Classification" : taskToDoValue === "Clustering" ? "Disabled for Clustering" : "Target Variable For Regression"} placeholder='Please select the variable'
                                    error={taskToDoValue === "Clustering" ? null : targetVarError}
                                    helperText={taskToDoValue === "Clustering" ? null : targetVarError ? 'Target variable is mandatory for Classification and Regression' : ''}
                                />}
                            />
                        </div>

                        {/* Scaling Strategy Section */}
                        <div style={{ ...rowStyle, alignItems: 'center', width: '100%' }}>
                            <h3 style={{ ...headingStyle, marginBottom: '1rem', minWidth: '200px', textAlign: 'left' }}><b>Scaling Strategy</b></h3>
                            <Autocomplete
                                id="combo-box-scaling-strategy"
                                options={scalingTechniqueOptions}
                                value={scalingTechniqueValue}
                                fullWidth
                                style={autocompleteStyle}
                                autoHighlight
                                onChange={handleScaling}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label="Scaling strategy" placeholder='Please select the Scaling strategy'
                                    error={scalingError}
                                    helperText={scalingError ? 'Scaling strategy is mandatory' : ''}
                                />}
                            />
                        </div>

                        {/* Feature Selection Section */}
                        <div style={{ ...rowStyle, alignItems: 'center', width: '100%' }}>
                            <h3 style={{ ...headingStyle, textAlign: 'left' }}><b>Feature Selection Methods : </b></h3>
                        </div>
                        <div style={{ ...rowStyle, alignItems: 'center', width: '100%' }}>
                            <label style={{  marginBottom: '1rem', marginLeft: '2rem', minWidth: '250px', textAlign: 'left' }}>Domain specific features</label>
                            <Autocomplete
                                id="combo-box-features"
                                value={featureValue}
                                multiple
                                options={allCleanedCols.filter(item => item != targetVariableValue && !timeStampCols.includes(item))}
                                fullWidth
                                style={{ ...autocompleteStyle, marginBottom: '10px', width: '100%' }}
                                autoHighlight
                                onChange={handleFeature}
                                renderInput={(params) => <TextField {...params} label="Select the feature" placeholder='Please select the feature' />}
                            />
                        </div>

                        {/* Remaining Features Section */}
                        <div style={{ ...rowStyle, alignItems: 'center' }}>
                            <label style={{ marginLeft: '2rem', minWidth: '250px', textAlign: 'left' }}>Auto feature selection on remaining variables ?</label>
                            <RadioGroup
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                                style={{ marginLeft: '1rem' }}
                                onChange={handleRemainingFeatures}
                                value={isRemainingFeatures}
                            >
                                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                                <FormControlLabel value="No" control={<Radio />} label="No" />
                            </RadioGroup>
                            {isRemainingFeatures === "Yes" &&
                                <Autocomplete
                                    id="combo-box-strategy-selection"
                                    options={taskToDoValue === "Classification" ? strategForFeatureSelectionOptions : strategForFeatureSelectionOptions1}
                                    value={strategForFeatureSelectionValue}
                                    fullWidth
                                    disabled={taskToDoValue === "Clustering"}
                                    style={{ ...autocompleteStyle, marginBottom: '10px', width: '300px', marginLeft: '1rem' }}
                                    autoHighlight
                                    onChange={handleStrategForFeatureSelectionChange}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        label="Strategy for feature selection"
                                        placeholder='Please select the strategy'
                                        error={taskToDoValue === "Clustering" ? null : featureSeletionStrategyError}
                                        helperText={taskToDoValue === "Clustering" ? null : featureSeletionStrategyError ? 'Strategy is mandatory' : ''}

                                    />}
                                />
                            }
                        </div>

                        {/* Perform Feature Processing Button */}
                        <div style={{ display: 'flex', justifyContent: 'start', marginTop: '1rem', alignItems: 'center' }}>
                            <Button
                                type="button"
                                variant="contained"
                                color="primary"
                                onClick={handleFeatureProcessingSubmit}
                                style={{ display: 'flex', marginLeft: '1rem' ,borderRadius:'16px'}}
                            >
                                Perform feature processing
                            </Button>
                            {loading &&
                                <div style={overlayStyle}>
                                    <div className="loader"></div>
                                </div>
                            }
                        </div>
                        {processedData && processedData.length > 0 ? <Card style={{ backgroundColor: '#f5f5f5', marginTop: '1rem' }}>
                            <CardContent>
                                <h3 style={{ ...labelStyle, marginLeft: '1rem', minWidth: '200px', textAlign: 'start' }}><b>Insights</b></h3>
                                <div style={paragraphStyle}>

                                    <ul>

                                        { <li>Number of data points : {noOfRowsAfterFeatureProcessing}</li>}
                                        {<li>Number of features : {noOfColsAfterFeatureProcessing}</li>}
                                        {<li>Selected features : {selectedFeaturesFromBackend && selectedFeaturesFromBackend.join(', ')}</li>}
                                       
                                    </ul>
                                </div>
                            </CardContent>
                        </Card> : ""}
                        


                        <CustomSnackbar open={snackbarOpen} onClose={handleSnackbarClose} snackbarType={snackbarType}
                            message={
                                snackbarType === 'success' ? featureStatusMsg :
                                    snackbarType === 'warning' ? "Upload warning" :
                                        snackbarType === 'error' ? featureStatusMsg :
                                            ""
                            }
                        />

                        {/* Data Cleaning Alert */}
                        {!cleanFlag &&
                            <Alert severity="warning" style={{ width: "40%", marginTop: "1rem", backgroundColor: "lightyellow" }}>
                                Please perform Data cleaning as it is mandatory for Feature Processing !!!
                            </Alert>
                        }

                        {/* Processed Data Table */}
                        <div style={{ display: 'flex', height: '40rem', maxWidth: '72vw', flexDirection: 'column', marginTop: '2rem', overflowX: 'auto' }}>
                            {processedData && processedData.length > 0 && <FeatureProcessedDataTable data={processedData} />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );





}

export default FeatureProcessing;
